var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"BtnIcon Upload",on:{"click":_vm.uploadFile}}),_c('input',{ref:"fileInput",attrs:{"type":"file","accept":"text/csv","hidden":""},on:{"change":_vm.importCsv}})])}
var staticRenderFns = []

export { render, staticRenderFns }